import {axios} from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {

  findByList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/productManagement/findByList`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findById({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/productManagement/findById`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  save({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/productManagement/save`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },


  upload({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/file/upload`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findByProductId({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/productManagement/findByProductId`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findByClassList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/productManagement/findByClassList`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // findByProductList({commit}, params) {
  //   return new Promise((resolve, reject) => {
  //     axios.post(`/productManagement/findByProductList`, params).then(response => {
  //       resolve(response)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },

  findByProductList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/productManagement/findByProductList`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  saveProduct({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/productManagement/saveProduct`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
// 保存机构产品
  saveProductByOrg({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/productManagement/saveProductByOrg`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findProductIdByOrg({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/productManagement/findProductIdByOrg`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
// 查看机构二维码
  findQRCodeByOrgId({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/productManagement/findQRCodeByOrgId`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
// 上传机构二维码
  uploadQRCodeByOrgId({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/productManagement/uploadQRCodeByOrgId`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findListByOrg({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/productManagement/findListByOrg`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  updateProductIdByTop({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/productManagement/updateProductIdByTop`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },


}









